import { z } from 'zod'

export const identityVerificationSchema = z.object({
  firstname: z.string().min(1, 'Meno je povinné'),
  lastname: z.string().min(1, 'Priezvisko je povinné'),
  confirm: z.boolean().refine((val) => val === true, {
    message: 'Označte prosím, že súhlasíte so spracovaním biometrických údajov',
  }),
  brokerCode: z.string().optional(),
})

export type IdentityVerificationSchema = z.infer<
  typeof identityVerificationSchema
>
